/**
 * Created by anatoly on 24.06.2025
 */

const Merge2NewUnitTutorial = function () {
    return new TutorialScenario(Merge2NewUnitTutorial.NAME, {
        listSteps: () => [
            Merge2TutorialHelper.createClickUnitStep({
                force: Forces.NEW_UNIT,
                filter: Merge2NewUnitTutorial.isSuitableUnit,
                finishEvent: "unitSelectionChanged"
            }),
            Merge2TutorialHelper.createUnitsLibraryStep({
                text: "Merge2.NewUnitTutorial2"
            })
        ],

        isAvailable: function () {
            return Merge2.current
                && Merge2.current.mode === Merge2.MODE_GAME
                && !Merge2.current.counter.isActive()
                && !cleverapps.forces.isShown(Forces.NEW_UNIT)
                && Merge2.current.field.listAvailableUnits(Merge2NewUnitTutorial.isSuitableUnit).length > 0;
        }
    });
};

Merge2NewUnitTutorial.isSuitableUnit = function (unit) {
    return unit.code === Merge2NewUnitTutorial.UNIT.code && unit.stage === Merge2NewUnitTutorial.UNIT.stage && !unit.findComponent(Grounded);
};

Merge2NewUnitTutorial.UNIT = {
    code: "c",
    stage: 0
};
Merge2NewUnitTutorial.NAME = "merge2_new_unit_tutorial";